import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-js';
import { BaseModal } from 'components/UI';
import { useSelector } from 'react-redux';
import { BasicInfo } from 'components/Invoice';
import { Button, Box } from '@material-ui/core';

export const InvoiceModal = ({ id, open, handleClick }) => {
  const formRef = useRef(null);
  const { loading } = useSelector((state) => state.invoice);

  return (
    <BaseModal
      size="lg"
      open={open}
      maxWidth={1160}
      loading={false}
      handleClick={handleClick}
      title={i18n.t('invoice.invoice_information')}
    >
      <Box display="flex" flexDirection="column" maxWidth={900} margin="0 auto">
        <BasicInfo mode="modal" formRef={formRef} handleSuccess={handleClick} />
        <Box display="flex" justifyContent="flex-end" mt={5}>
          <Button
            type="submit"
            color="primary"
            disabled={loading}
            variant="contained"
            data-cy="edit-invoice-information"
            onClick={() => formRef.current.submitForm()}
          >
            {i18n.t('common.save')}
          </Button>
        </Box>
      </Box>
    </BaseModal>
  );
};

InvoiceModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired,
};

InvoiceModal.defaultProps = {
  open: false,
  handleClick: () => {},
};
